export enum miscellaneous {
    STOCK_EMPLOYEE_IMAGE = 'assets/icons/stock-user.svg',
    STOCK_EMPLOYEE_IMAGE_PNG = 'assets/icons/user-icon-blank.png',
    BENEFIT_ICON = 'assets/icons/benefit-icon.png',
}
  